<div class="wrapperOnboarding"
     [stepContent]="searchAlertPopupContent"
     [joyrideStep]="'searchAlertPopupStep'"
     (prev)="onNoClick()">
    <div class="fs-2 with-close" mat-dialog-title>
        Gestion de votre alerte
        <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
    </div>
    <div mat-dialog-content>
        <b class="subtitle">Votre alerte "{{ currentSearch.title }}" : </b>
        <p>
            Gérez ici les alertes mail de vos recherches:
        </p>
        <ul>
            <li>Recevez toutes les nouvelles annonces qui vous correspondent en direct dans votre boite mail</li>
            <li>Vous ne recevez que les nouveaux bien (et non pas les annonces postées en boucle)</li>
        </ul>

        <form (ngSubmit)="onYesClick()" [formGroup]="alertForm">
            <b class="subtitle mb-2 d-block">Fréquence des mails : </b>
            <mat-radio-group formControlName="frequency_alert" aria-label="Selectionner la frequence">
                <div class="row">
                    <div class="col-md-12 mb-1">
                        <mat-radio-button value="1">2 fois / semaine</mat-radio-button>
                        <br/>
                    </div>
                    <div class="col-md-4 mb-1">
                        <mat-radio-button value="2" (click)="upgradePlan('assets/upgrade/alert.png', 'Alertes E-mailsfavorite_list_', 'Expert');">
                            Tous les matins
                            <i *ngIf="!authenticationService.isAllowed('expert')" class="fa fa-lock"
                               matTooltipClass="tooltip-button" matTooltip="Nécessite un forfait Expert"></i>
                        </mat-radio-button>
                    </div>
                    <div class="col-md-4 mb-1">
                        <mat-radio-button value="3" (click)="upgradePlan('assets/upgrade/alert.png', 'Alertes E-mailsfavorite_list_', 'Expert');">
                            Tous les midi
                            <i *ngIf="!authenticationService.isAllowed('expert')" class="fa fa-lock"
                               matTooltipClass="tooltip-button" matTooltip="Nécessite un forfait Expert"></i>
                        </mat-radio-button>

                    </div>
                    <div class="col-md-4 mb-1">
                        <mat-radio-button value="4" (click)="upgradePlan('assets/upgrade/alert.png', 'Alertes E-mailsfavorite_list_', 'Expert');">
                            Tous les soirs
                            <i *ngIf="!authenticationService.isAllowed('expert')" class="fa fa-lock"
                               matTooltipClass="tooltip-button" matTooltip="Nécessite un forfait Expert"></i>
                        </mat-radio-button>
                        <br/>

                    </div>
                    <div class="col-md-4 mb-1">
                        <mat-radio-button value="5" (click)="upgradePlan('assets/upgrade/alert.png', 'Alertes E-mails', 'Expert');">
                            Matins et soirs
                            <i *ngIf="!authenticationService.isAllowed('expert')" class="fa fa-lock"
                               matTooltipClass="tooltip-button" matTooltip="Nécessite un forfait Expert"></i>
                        </mat-radio-button>

                    </div>
                    <div class="col-md-4 mb-1">
                        <mat-radio-button value="6" (click)="upgradePlan('assets/upgrade/alert.png', 'Alertes E-mails', 'Expert');">
                            Matin / midi et soir
                            <i *ngIf="!authenticationService.isAllowed('expert')" class="fa fa-lock"
                               matTooltipClass="tooltip-button" matTooltip="Nécessite un forfait Expert"></i>
                        </mat-radio-button>
                        <br/>

                    </div>
                    <div class="col-md-12 mb-1">
                        <mat-radio-button value="7" (click)="upgradePlan('assets/upgrade/alert.png', 'Alertes E-mails', 'Expert');">
                            En instantanées
                            <i *ngIf="!authenticationService.isAllowed('expert')" class="fa fa-lock"
                               matTooltipClass="tooltip-button" matTooltip="Nécessite un forfait Expert"></i>
                        </mat-radio-button>
                        <br/>

                    </div>
                    <div class="col-md-12">
                        <mat-radio-button value="0">
                            Aucun
                        </mat-radio-button>
                    </div>
                </div>
            </mat-radio-group>
            <hr/>
            <mat-checkbox formControlName="price_alert">
                Recevoir les baisses de prix<br/>
                <em>(Soyez alerté des anciennes annonces dont le prix a baissé)</em>
            </mat-checkbox>
        </form>
<!--        <a href="#" onclick="WonderPush.subscribeToNotifications(event); return false;">Click me to subscribe</a>-->
    </div>
    <div mat-dialog-actions>
        <button (click)="onNoClick()" type="reset" class="btn btn-outline">
            Annuler
        </button>
        <button type="button" (click)="onYesClick()" class="btn btn-primary"
                [stepContent]="valideAlertPopupContent"
                [joyrideStep]="'valideAlertPopupStep'">
                <mat-spinner diameter="26" *ngIf="loading"></mat-spinner>
                <ng-container *ngIf="!loading">Enregistrer</ng-container>
        </button>
    </div>
</div>

<!-- Onboarding -->
<ng-template #searchAlertPopupContent>
    <div class="user_onboarding_content">
        <h2>Créer votre alerte mail</h2>
        <p>
            Vous allez pouvoir <b>gérer vos alertes mails</b> depuis ce menu.<br/>
            <br/>
            Pour ce faire, c’est très simple :
        </p>
        <ul>
            <li>Sélectionnez une recherche enregistrée</li>
            <li>Choisissez la fréquence de réception des mails</li>
        </ul>
        <p>
            Et c’est parti, <b>les bonnes affaires</b> arrivent directement dans votre boîte mail 😉<br/>
            <br/>
            <b>Astuce</b> : Vous pouvez aussi être alerté quand une annonce est re-postée avec une baisse de prix
        </p>
    </div>
</ng-template>

<ng-template #valideAlertPopupContent>
    <div class="user_onboarding_content">
        <h2>Créer votre alerte mail</h2>
        <p>
            Pour valider votre alerte, cliquez ici
        </p>
    </div>
</ng-template>
